
angular.module('tf.services')

    .service('Legend', ['$state','C3Service',function($state, C3Service) {


        var initialSize = 5;

        this.create = function legend(element, chart, data, clickKey){
            d3.select(element[0].parentElement).selectAll('.legend').remove();
            if(!data){return;}
            var meta = data.meta || {};
            data = C3Service.getSortedCategories(data.values);

            var shown;
            try{
                shown = data.length? _.pluck(chart.data.shown(), 'id') : [];
            } catch(e){
                shown = data;
            }

            function isShown(id){
                return shown.indexOf(id) >= 0;
            }

            var showingAll = element.hasClass('show-more');



            function showMore(){
                legend.classed('hide', false);
                element.addClass('show-more');
                shoeMoreButton.html('show less');
            }
            function showLess(){
                element.removeClass('show-more', false);
                legend.classed('hide', function(id,i){
                    return i >= initialSize && !isShown(id);
                });
                shoeMoreButton.html('show more...');
            }
            function toggleLegend() {
                if(showingAll){
                    showLess();
                } else {
                    showMore();
                }
                showingAll = !showingAll;
            }

            var legend = d3.select(element[0].parentElement).append('div').attr('class', 'legend').selectAll('span')
                .data(data)
                .enter()
                .append('div')
                .attr('class', 'legend-item')
                .attr('data-id', function (id) {return id; })
                .classed('hide', function(id, i){
                   return !showingAll && i >= initialSize && !isShown(id);
                });

            legend
                .append('div')
                .attr('class', 'legend-box')
                .each(function (id) {
                    d3.select(this).style('background-color', chart.color(id));
                    d3.select(this).style('border-color', chart.color(id));
                })
                .classed('active', function(d){
                    return !isShown(d);
                })
                .on('mouseover', function (id) {
                    if(isShown(id)){
                        chart.focus(id);
                    }
                })
                .on('mouseout', function (id) {
                    chart.revert();
                })
                .on('click', function (id) {
                    chart.toggle(id);
                    $(this).toggleClass('active');
                    chart.revert();
                });

            legend
                .append('span')
                .attr('class', 'legend-text')
                .html(function (id) { return id; })
                .classed('clickable', function(d){
                    return !!clickKey;
                })
                .on('mouseover', function (id) {
                    if(isShown(id)){
                        chart.focus(id);
                    }
                })
                .on('mouseout', function (id) {
                    chart.revert();
                })
                .on('click', function(id){
                    // var slice = meta[id];
                    // if(slice){
                    //     $state.go('app.statistics.dashboard', {encoded : slice.url});
                    // }
                    if(clickKey){
                        var properties = {};
                        properties[clickKey] = id;
                        $state.go('app.statistics.dashboard', properties);
                    }

                });
            var shoeMoreButton;
            if(data.length > initialSize){
                shoeMoreButton = d3.select($(element[0].parentElement).find('.legend')[0])
                    .append('a')
                    .classed('show-more-button', true)
                    .html(showingAll ? 'show less' : 'show more...')
                    .on('click', function () {
                        toggleLegend();
                    });
            }

        };

        return this;


    }]);
